import React, { useState, useEffect } from "react";
import "./RequestServiceForm.css";

const RequestServiceForm = React.forwardRef(({ showCloseButton = true, ...props }, ref) => {
  const [autoCompleteValue, setAutoCompleteValue] = useState("off");

  useEffect(() => {
    const timer = setTimeout(() => {
      setAutoCompleteValue("new-password");
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="request-service-form-section" ref={ref}>
      <div className="form-container white-form-background" onClick={props.onClick}>
        {showCloseButton && <button className="close-button" onClick={props.onClose}>X</button>}
        <h2>Request a Service</h2>
        <form autoComplete={autoCompleteValue}>
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" name="name" required autoComplete={autoCompleteValue} />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required autoComplete={autoCompleteValue} />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone:</label>
            <input type="tel" id="phone" name="phone" autoComplete={autoCompleteValue} />
          </div>
          <div className="form-group">
            <label htmlFor="service">Service Needed:</label>
            <select id="service" name="service" autoComplete={autoCompleteValue}>
              <option value="">--Please choose an option--</option>
              <option value="electrical-panel">Electrical Panel Upgrade</option>
              <option value="ev-charger">EV Charger Installation</option>
              <option value="lighting">Lighting Installation</option>
              <option value="renovation">Renovation Wiring</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea id="message" name="message" rows="5" autoComplete={autoCompleteValue}></textarea>
          </div>
          <div className="form-button-container">
            <button type="submit" className="submit-button">
              Submit Request
            </button>
          </div>
        </form>
        <p className="phone-number">Or call us at: (403)369-7980</p>
      </div>
    </div>
  );
});

export default React.memo(RequestServiceForm);